export default __webpack_public_path__ + "static/media/history.d2001313.svg";